export const toolTypes = {
  visual_media: {
    id: "visual_media",
    title: "Visual Learner",
    label: "YouTube & Animationen",
    description: "Du lernst am besten durch Erklärvideos, Animationen und dynamische Visualisierungen.",
    tools: ["YouTube-Videos", "Animationen", "GeoGebra"],
    color: "violet",
  },
  interactive: {
    id: "interactive",
    title: "Interaktiver Entdecker",
    label: "GeoGebra & JS-Rechner",
    description: "Du brauchst das direkte Ausprobieren mit interaktiven Werkzeugen wie GeoGebra oder JS-Rechnern.",
    tools: ["GeoGebra", "JS-Rechner", "Simulationen"],
    color: "cyan",
  },
  systematic: {
    id: "systematic",
    title: "KI-gestützter Lerner",
    label: "KI-Chat & Strukturen",
    description: "Du arbeitest mit KI-Chats, klaren Strukturen und organisierten Schritt-für-Schritt-Anleitungen.",
    tools: ["KI-Chat", "Checklisten", "Boards"],
    color: "emerald",
  },
  repetitive: {
    id: "repetitive",
    title: "Wiederholungs-Profi",
    label: "Quizzes & Übungsaufgaben",
    description: "Du festigst Wissen durch aktives Abrufen, Übungsaufgaben und regelmäßige Selbsttests.",
    tools: ["Übungsaufgaben", "Quizzes", "KI-Feedback"],
    color: "amber",
  },
};